(function(angular) {
    'use strict';

    angular.module('app').factory('ContentAttributeService', [
        'UrlParsingService',
        ContentAttributeService
    ]);

    function ContentAttributeService(
        UrlParsingService
    ) {
        return {
            getClientConfig: getClientConfig,
        };

        function getClientConfig() {
            return UrlParsingService.parsePortalUrl('/facilityportal/');
        }
    }
})(window.angular);